// Pré-digitação do Aumento de Margem INSS (E1). Contrato de /simulation/inss-margin no
// beviajuda-api — o agente sai do token, o front nunca envia código de parceiro.

// A aba "descartadas" aparece na tela como "Arquivadas"; o valor segue o contrato da API.
export type InssMarginTab = 'oportunidades' | 'descartadas';

export const INSS_MARGIN_PER_PAGE = 50;

// O `id` é o que se envia ao marcar financeiras: na carteira quase nenhuma tem `code`.
export interface InssMarginFinancial {
    id: string;
    code: string | null;
    name: string;
}

export type InssMarginDataSource = 'base' | 'parceiro' | null;

export interface InssMarginItem {
    id: string;
    cpf: string;
    name: string;
    name_source: InssMarginDataSource;
    phone: string | null;
    phone_source: InssMarginDataSource;
    state: string | null;
    last_proposal_at: string | null;
    financials: string[];
    situation: 'oportunidade' | 'descartada';
    validated_at: string | null;
    discarded_at: string | null;
    discarded_reason: string | null;
}

export interface InssMarginTotals {
    oportunidades: number;
    descartadas: number;
}

export interface InssMarginListResponse {
    items: InssMarginItem[];
    totals: InssMarginTotals;
    total: number;
    message: string | null;
    page: number;
    perPage: number;
    lastPage: number;
}

export interface InssMarginDiscardReason {
    code: string;
    text: string;
}

// Destaque verde já marcado ao abrir o balão de arquivar.
export const INSS_MARGIN_HIGHLIGHT_REASON = 'ja_digitada';
// Motivo que abre o campo de observação.
export const INSS_MARGIN_OTHER_REASON = 'outro';

export type InssMarginPartnerField = 'name' | 'birth_date' | 'phone' | 'email';

export interface InssMarginRecordClient {
    cpf: string;
    name: string;
    birth_date: string | null;
    phone: string | null;
    email: string | null;
    state: string | null;
    phone_source: InssMarginDataSource;
    validated_at: string | null;
    partner_fields: InssMarginPartnerField[];
}

export interface InssMarginRecordOpportunity {
    id: string;
    situation: 'oportunidade' | 'descartada';
    financials: string[];
    discarded_at: string | null;
    discarded_reason: string | null;
    discarded_note: string | null;
}

// Resumo dos contratos do cliente com o agente (a carteira não lista contrato a contrato).
export interface InssMarginRecordHistory {
    contracts_count: number;
    total_amount: number;
    first_proposal_at: string | null;
    last_proposal_at: string | null;
    contract_types: string[];
    financials: string[];
}

export interface InssMarginRecord {
    client: InssMarginRecordClient;
    opportunity: InssMarginRecordOpportunity;
    history: InssMarginRecordHistory;
}

export interface InssMarginClientForm {
    name: string;
    birth_date: string;
    phone: string;
    email: string;
}

export type InssMarginFieldErrors = Partial<Record<keyof InssMarginClientForm, string>>;

export interface InssMarginIndicators {
    portfolio: number;
    simulated: number;
    typed: number;
    typed_amount: number;
}